import { render, staticRenderFns } from "./ReportManagement.vue?vue&type=template&id=1a95759c&scoped=true&"
import script from "./ReportManagement.vue?vue&type=script&lang=js&"
export * from "./ReportManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReportManagement.vue?vue&type=style&index=0&id=1a95759c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95759c",
  null
  
)

export default component.exports